import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var personalAndGiftShoppingIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 6.25h-3.25c-.68-3.62-2.53-6-4.75-6s-4.07 2.38-4.75 6H4a.76.76 0 0 0-.75.75v12A4.75 4.75 0 0 0 8 23.75h8A4.75 4.75 0 0 0 20.75 19V7a.76.76 0 0 0-.75-.75Zm-8-4.5c1.38 0 2.66 1.84 3.22 4.5H8.78c.56-2.66 1.84-4.5 3.22-4.5ZM19.25 19A3.26 3.26 0 0 1 16 22.25H8A3.26 3.26 0 0 1 4.75 19V7.75H7l-.24 2.16.49.06a1 1 0 0 0 1.12-.87l.17-1.35h6.92l.17 1.35a1 1 0 0 0 1.12.87l.49-.06L17 7.75h2.28L19.25 19Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.003 17.074a.406.406 0 0 1-.243-.079c-.576-.412-1.964-1.473-2.476-2.425-.361-.655-.449-1.58.163-2.158.594-.55 1.51-.55 2.104 0l.452.436.448-.427c.594-.55 1.51-.55 2.104 0 .606.579.524 1.516.164 2.158-.513.94-1.898 2.004-2.47 2.425a.421.421 0 0 1-.246.07Z",
  fillRule: "nonzero"
})));

export { personalAndGiftShoppingIcon as default };
//# sourceMappingURL=personalAndGiftShoppingIcon.js.map
